import ApiService from "../services/api.service";
import { isUnauthorizedError } from "../utils/errorHandling";

const toValue = (source, fallback = null) => {
	if (source && typeof source === "object" && "value" in source) return source.value;
	if (typeof source !== "undefined") return source;
	return fallback;
};

const setRef = (target, value) => {
	if (typeof target === "function") {
		target(value);
		return;
	}
	if (target && typeof target === "object" && "value" in target) {
		target.value = value;
	}
};

export function useBrandPopupHandlers(options = {}) {
	const {
		api = ApiService,
		toastError,
		updateLoadingText,
		brandAction,
		closePopup,
		setShowMessageInfo,
		setActionBrandId,
		setShowPupup,
		setShowReportBrand,
		setShowBadgeInfo,
		setShowToggleShowInfoPupup,
		closeNewbiePupup,
		showSubscriptionPupup,
		paymentRedirect,
		subscriptionTitle,
	} = options;

	const action = ({ brandId, action, forceIt } = {}) => {
		if (typeof brandAction === "function") {
			brandAction({ brandId, action, forceIt });
			return;
		}
		if (toastError) toastError("This action is not available in this view.", "Action");
	};

	const viewMessage = (messageInfo) => {
		const connectorId = messageInfo?.connector;
		const connecteeId = messageInfo?.connectee;

		if (!connectorId || !connecteeId) {
			if (toastError) toastError("Unable to open this message right now.", "Oops");
			return;
		}

		if (!api || !setShowMessageInfo || !setActionBrandId || !setShowPupup || !updateLoadingText) {
			if (toastError) toastError("Unable to open this message in this view.", "Oops");
			return;
		}

		updateLoadingText(true);
		api.get(`brands/connection-message/${connectorId}/${connecteeId}`)
			.then((response) => {
				setRef(setShowMessageInfo, response.data);
				setRef(setActionBrandId, connectorId);
				setRef(setShowPupup, true);
				updateLoadingText();
			})
			.catch((error) => {
				updateLoadingText();
				if (toastError && !isUnauthorizedError(error)) toastError(`${error}`, "Oops");
			});
	};

	const reportBrand = (brandId) => {
		if (setShowReportBrand) {
			setRef(setShowReportBrand, brandId);
			return;
		}
		if (toastError) toastError("Reporting is not available in this view.", "Oops");
	};

	const badgeInfo = (payload) => {
		if (setShowBadgeInfo) {
			setRef(setShowBadgeInfo, {
				show: true,
				key: payload?.type || payload?.key || "",
			});
		}
	};

	const toggleShowInfo = () => {
		if (setShowToggleShowInfoPupup) {
			setRef(setShowToggleShowInfoPupup, true);
		}
	};

	const subscribe = () => {
		if (typeof closeNewbiePupup === "function") closeNewbiePupup();
		if (typeof showSubscriptionPupup === "function") {
			showSubscriptionPupup({ paymentRedirect: toValue(paymentRedirect, ""), title: toValue(subscriptionTitle, "") });
		}
	};

	const close = () => {
		if (typeof closePopup === "function") closePopup();
	};

	return {
		action,
		viewMessage,
		reportBrand,
		badgeInfo,
		toggleShowInfo,
		subscribe,
		close,
	};
}
